import React from "react";
import { connect } from "react-redux";
import {
  guardarAplicacionExterna,
  editarAplicacionExterna,
} from "../../components/aplicacionExterna/AplicacionExternaService";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa
} from "../../constans/constants";
import { exportarDocumento } from "../lotes/LoteService";
import axios from "axios";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { logout } from "../login/SesionService";
import { getUsuario } from "../usuario/UsuarioService";
import { agregarMiembro } from "./OrganizacionService";
import BuscadorPorCedula from "../componentes/BuscadorPorCedula";
import BusquedaUsuario from "../componentes/BusquedaUsuario";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import ComponenteVacio from "../componentes/avisos/ComponenteVacio";

class Miembro extends React.Component {
  constructor(props) {
    super(props);
    var today = new Date(),
      date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
    this.state = {
      descripcion: "",
      numeroPatronal: [],
      gruposUsuarios: [],
      unidades: [],
      lote: [],
      id: "",
      date: date,
      file: null,
      uploadDisabled: false,
      numeroPatronalID: "",
      unidadID: "",
      idGrupo: "",
      isCarpetaPorDefecto: false,
      carpetaPorDefecto: "",
      fileErrorMsg: "",
      path: "",
      mensaje: "",
      severity: "",
      mostrarMensajeFlash: false,
      submit: false,
      openPantallaCarga: false,
      validated: false,
      requiredNroMtess: false,
      grupoCheckBox: false,
      idColaborador: "",
      usuarioData: {},
      hayDatosUsuario: false,
      mensajeConsultaUsuario: "",
      cedula: "",
      miembros: [],
      cargo: [],
      cargoID: ""
    };

    this.tablaRef = React.createRef();
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleDialogImport = (value) => {
    this.setState({
      resultImportPopUp: value,
    });
  };

  agregarUsuario(usuariosData) {
    this.setState({ idColaborador: usuariosData.id });
  }

  handleChecked = (event) => {
    var name = event.target.name;
    var val = event.target.checked;
    this.setState({
      [name]: val,
      idGrupo: "",
    });
  };

  obtenerUsuario = async () => {

    this.setState({ usuarioData: {}, hayDatosUsuario: false });
    if (this.state.cedula != "") {
      await axios
        .get(
          URL + "usuario/obtenerDatosColaborador/" + this.state.cedula + "/" + idEmpresa(),
          getAuthorizationHeader()
        )
        .then(
          (res) => {
            if (!res.data.error) {
              this.setState({
                usuarioData: res.data.datos,
                hayDatosUsuario: true,
              });
            } else {
              this.setState({ mensajeConsultaUsuario: res.data.mensaje });
            }
          },
          (error) => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          }
        );
    } else {
      this.setState({
        mensajeConsultaUsuario: "Debe ingresar un numero de cedula"
      })
    }

  };

  componentDidMount() {
    this.setState({ cargo: [{ id: 1, nombre: "Supervisor" }, { id: 2, nombre: "Miembro" }] })
    this.setState({ unidadID: this.props.location.state.unidadID })
    if (this.props.location.state.miembros) {
      this.setState({ miembros: this.props.location.state.miembros })
      this.setState({ hayDatosUsuario: true })
    }
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
    if (name == "unidadID") {
      const unidad = this.state.unidades.find((u) => u.id == val);
      const miembros = unidad && unidad.miembros ? unidad.miembros : [];
      this.setState({ miembros: miembros });
    }
  };

  agregarNuevoMiembroLista = async () => {
    this.setState({ mensajeConsultaUsuario: "" });
    var existeUsuario = false;
    if (this.state.miembros) {
      const usuario = this.state.miembros.find(u => u.cedula === this.state.cedula)
      if (usuario) {
        existeUsuario = true;
      }
    }
    if (existeUsuario) {
      this.setState({ mensajeConsultaUsuario: "El usuario ya se encuentra registrado en la unidad" });
    } else {
      if (this.state.cargoID != "") {
        await this.obtenerUsuario()
        if (this.state.usuarioData.usuario) {
          const nuevoMiembro = {
            apiUsername: null,
            apiPassword: null,
            apiKey: null,
            usuario: this.state.usuarioData.id,
            name: this.state.usuarioData.nombreApellido,
            lastname: this.state.usuarioData.nombreApellido,
            username: this.state.usuarioData.usuario,
            email: null,
            phoneNumber: null,
            cedula: this.state.usuarioData.cedula,
            userId: null,
            empresaId: null,
            activo: null,
            nroPersonalIps: null,
            nroTrabajoMtess: null,
            roles: null,
            cargo: this.state.cargoID
          };

          const nuevosMiembros = [...this.state.miembros];
          nuevosMiembros.push(nuevoMiembro);
          this.setState({ miembros: nuevosMiembros });
        }
      } else {
        this.setState({ mensajeConsultaUsuario: "Se debe asignar un cargo al usuario" });
      }
    }
  }

  guardarMiembro = event => {
    event.preventDefault();
    agregarMiembro(this.state.miembros, this.state.unidadID)
      .then((respuesta) => {
        this.props.history.push({
          pathname: '/estructura/organizacion',
          state: {
            mostrarMensajeFlash: true,
            mensajeFlash: respuesta.error ? 'Ocurrio un error al guardar los cambios realizados' : 'Cambios en miembros realizado',
            mensajeFlashSeverity: respuesta.error ? 'error' : 'exito'
          }
        })

      }).catch(error => {
        this.props.handleClose(true)
      });
  }

  eliminarMiembro = (id) => {
    const nuevosMiembros = this.state.miembros.filter(miembro => miembro.usuario !== id);
    this.setState({ miembros: nuevosMiembros });
  }

  fetchUsuarios = () => {
    return Promise.resolve(this.state.miembros);
  };


  handleUsuarioSeleccionado = (usuario) => {
    const yaExiste = this.state.miembros.some(m => m.cedula === usuario.cedula);
    if (yaExiste) {
      this.setState({ mensajeConsultaUsuario: "El usuario ya se encuentra en la lista." });
      return;
    }

    if (this.state.cargoID === "") {
      this.setState({ mensajeConsultaUsuario: "Debe seleccionar un cargo antes de agregar un usuario." });
      return;
    }

    const nuevoMiembro = {
      usuario: usuario.id,
      name: usuario.nombreApellido,
      lastname: usuario.nombreApellido,
      username: usuario.usuario,
      email: usuario.email,
      phoneNumber: usuario.celular,
      cedula: usuario.cedula,
      cargo: this.state.cargoID
    };

    this.setState((prevState) => ({
      miembros: [...prevState.miembros, nuevoMiembro],
      mensajeConsultaUsuario: ""
    }));
  }

  renderTablaUsuarios = () => {
    return (
      <div className="component-table">
        <div className="responsive-table">
          <table>
            <thead>
              <tr>
                <th>Identificador</th>
                <th>Nombres y apellidos</th>
                <th>Nombre de usuario</th>
                <th>Cargo</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.miembros.map((miembro, index) => (
                <tr key={index}>
                  <td>{miembro.cedula}</td>
                  <td>{miembro.name}</td>
                  <td>{miembro.username}</td>
                  <td>
                    <span className="label__success">{miembro.cargo}</span>
                  </td>
                  <td>
                    <div className="table-actions">
                      <button
                        className="table-icon open-dialog"
                        onClick={() => this.eliminarMiembro(miembro.usuario)}
                        data-dialog="modal-delete-details"
                      >
                        <span className="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  handleUsuariosChange = (datos) => {

    const cargoAsignado = this.state.cargoID === "" ? "Miembro" : this.state.cargoID

    const dato = datos[datos.length - 1]

    const nuevoMiembro = {
      apiUsername: null,
      apiPassword: null,
      apiKey: null,
      usuario: dato.id,
      name: dato.nombreApellido,
      lastname: dato.nombreApellido,
      username: dato.usuario,
      email: null,
      phoneNumber: null,
      cedula: dato.cedula,
      userId: null,
      empresaId: null,
      activo: null,
      nroPersonalIps: null,
      nroTrabajoMtess: null,
      roles: null,
      cargo: cargoAsignado
    };
/*
    const nuevoMiembro = {
      usuario: dato.id,
      name: dato.nombreApellido,
      lastname: dato.nombreApellido,
      username: dato.usuario,
      email: dato.email,
      phoneNumber: dato.celular,
      cedula: dato.cedula,
      cargo: this.state.cargo.find((cargo) => cargo.id == idCargo)
    };
*/
    this.setState((prevState) => ({
      miembros: [...prevState.miembros, nuevoMiembro],
      cargoID: cargoAsignado
    }));
  };

  render() {
    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">
            <BreadCrumComponent
              backUrl={'/estructura/organizacion/'}
              breadcrumbs={
                [
                  { label: 'Organigrama', path: '/estructura/organizacion/' },
                  { label: 'Editar Unidad', path: '' },
                  { label: 'Agregar miembro', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> Agregar miembro a la unidad </h1>
                <p className="page-description"> Está editando la unidad </p>
              </div>
              <div className="head-actions">
                <button onClick={this.guardarMiembro} className="btn-medium btn-primary"> Guardar cambios </button>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="page-container">

            <form className="form">
              <div className="form-group__inline w-50 mt-0">
                <div className="form-group">
                  <select className="form-select" name="cargoID" id="cargoID" value={this.state.cargoID} onChange={this.handleInput}>
                    <option key="" value=""></option>
                    {this.state.cargo.map((elemento) => (
                      <option key={elemento.nombre} value={elemento.nombre}>
                        {elemento.nombre}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="cargoID" className="form-label"> Cargo </label>
                </div>
                <div>
                  <BusquedaUsuario
                    selectedUsers={this.state.miembros}
                    onSelectedUsersChange={this.handleUsuariosChange}

                  />
                </div>
              </div>
            </form>
            {this.state.miembros.length == 0
              ? <ComponenteVacio />
              : this.renderTablaUsuarios()
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarAplicacionExterna: (value) =>
    dispatch(guardarAplicacionExterna(value)),
  editarAplicacionExterna: (value) => dispatch(editarAplicacionExterna(value)),
  exportarDocumento: (file) => dispatch(exportarDocumento(file)),
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search)),
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Miembro);
